import { useMemo } from "react";
import { useFlags } from "../../../lib/flags";

export const useCanSummonApp = () => {
  return true;
};

export const useCanScaffoldApp = () => {
  const flags = useFlags();

  return useMemo(() => {
    return flags.features.scaffoldApps;
  }, [flags]);
};
